import React, { useEffect, Fragment } from "react";
import { CircularProgress } from "@material-ui/core";
import { useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import { useAlert } from "../../components/Alert";
import Grid from "../../components/Grid";
import Button from "../../components/Button";

const GET_FORECLOSURES = gql`
  query foreclosures(
    $obj_str: String
    $obj_share: String
    $obj_caseno: String
    $obj_another: String
    $desc: Boolean
    $pageSize: Int
    $page: Int
  ) {
    foreclosures(
      obj_str: $obj_str
      obj_share: $obj_share
      obj_caseno: $obj_caseno
      obj_another: $obj_another
      desc: $desc
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        obj_time
        obj_link
        obj_stop
        obj_stop_link
      }
    }
  }
`;

export default function BulletinLink({ data }) {
  const Alert = useAlert();
  const [getForeclosures, { data: getForeclosuresData, loading }] =
    useLazyQuery(GET_FORECLOSURES, {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      onError(error) {
        Alert.alert("通知", `${error}`, [
          {
            text: "確定",
            type: "ok",
          },
        ]);
      },
    });

  useEffect(() => {
    if (!!data.obj_caseno) {
      getForeclosures({
        variables: {
          obj_str: data.obj_str,
          obj_share: data.obj_share,
          obj_caseno: data.obj_caseno,
          obj_another: data.obj_another,
          desc: false,
          pageSize: 999,
          page: 1,
        },
      });
    }
  }, [data]);
  if (false) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <>
        {getForeclosuresData?.foreclosures?.contents.map((item, index) => {
          return (
            <Fragment key={index}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onPress={() => {
                    window.open(`${item.obj_link}`, "_blank", "noopener");
                  }}
                >
                  {item.obj_time === "0" ? "應買" : `${item.obj_time}拍`}
                </Button>
              </Grid>
              {item.obj_stop !== "" && (
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onPress={() => {
                      window.open(
                        `${item.obj_stop_link}`,
                        "_blank",
                        "noopener"
                      );
                    }}
                  >
                    停拍
                  </Button>
                </Grid>
              )}
            </Fragment>
          );
        })}
      </>
    );
  }
}
